/*
 * @Author: Ryan
 * @Date: 2026-01-09
 * @Description: Footer CTA Section for Video Translator landing page
 */
import React from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';

import styles from './index.module.scss';

export interface FooterCTASectionProps {
  /** 区块标题 */
  title: string;
  /** 区块描述 */
  subtitle: string;
  /** CTA 按钮文本 */
  ctaText: string;
  /** CTA 跳转链接 */
  ctaUrl?: string;
}

const FooterCTASection: React.FC<FooterCTASectionProps> = ({
  title,
  subtitle,
  ctaText,
  ctaUrl = '/ai-video-generator',
}) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 描述 */}
        <p className={styles.subtitle}>{subtitle}</p>

        {/* CTA 按钮 */}
        <div className={styles.ctaWrapper}>
          <StartButton text={ctaText} href={ctaUrl} className={styles.ctaButton} />
        </div>
      </div>
    </section>
  );
};

export default FooterCTASection;
